import Vue from 'vue'
import './assets/main.css'
import App from './App.vue'

new Vue({
  render: (h) => h(App),
}).$mount('#app')
